export default __webpack_public_path__ + "static/digilock-europe-netherlands-6b5d65d09e8802ae143600af1b830004.jpg";